var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 0v20zM0 0v20zm13.116 12.177L10 9.061l-3.116 3.116a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707l3.47-3.469a1 1 0 0 1 1.414 0l3.47 3.469a.5.5 0 0 1 0 .707l-.354.354a.5.5 0 0 1-.707 0"
})));
export default SvgArrowUpSmall;